'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty = require('babel-runtime/core-js/object/define-property');

var _defineProperty2 = _interopRequireDefault(_defineProperty);

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _desc, _value, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _mobx = require('mobx');

var _getNested = require('get-nested');

var _getNested2 = _interopRequireDefault(_getNested);

var _RuleHint = require('../RuleHint');

var _RuleHint2 = _interopRequireDefault(_RuleHint);

var _rules = require('../Webform/rules');

var _rules2 = _interopRequireDefault(_rules);

var _index = require('../index');

var _conditionals = require('../Webform/conditionals');

var _WebformUtils = require('../WebformUtils');

var _WebformUtils2 = _interopRequireDefault(_WebformUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _initDefineProp(target, property, descriptor, context) {
  if (!descriptor) return;
  (0, _defineProperty2.default)(target, property, {
    enumerable: descriptor.enumerable,
    configurable: descriptor.configurable,
    writable: descriptor.writable,
    value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
  });
}

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function _initializerWarningHelper(descriptor, context) {
  throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
}

var Field = (_class = function () {

  /**
   * As soon as the field was ever blurred or an user tries to submit an page, this value becomes true.
   * It can be used to determine if the field should display a checkmark or errors etc.
   * @type {boolean}
   */


  /**
   * @deprecated
   * Better not use the component at all. All logic should be in this file
   */

  /**
   *
   * @type {Array.<Field>}
   */


  /**
   * @var Form
   */
  function Field(formStore, element, parent) {
    var _this = this;

    (0, _classCallCheck3.default)(this, Field);
    this.parents = [];
    this.page = 'no-page';

    _initDefineProp(this, 'component', _descriptor, this);

    _initDefineProp(this, 'value', _descriptor2, this);

    _initDefineProp(this, 'isBlurred', _descriptor3, this);

    _initDefineProp(this, 'lookUps', _descriptor4, this);

    if (!element['#webform_key']) {
      throw new Error('Element key is required');
    }

    this.value = element['#value'] || element['#default_value'] || '';

    this.formStore = formStore;
    this.key = element['#webform_key'];
    this.element = element;
    this.componentClass = _index.components[element['#type']] || _index.components.default;
    this.conditionals = (0, _conditionals.formatConditionals)(element['#states']);
    this.parent = parent;
    if (parent) {
      this.parents = [parent].concat((0, _toConsumableArray3.default)(this.parent.parents));
    }
    if (element['#type'] === 'webform_wizard_page') {
      this.page = this.key;
    } else if (parent) {
      this.page = this.parent.page;
    }

    _rules2.default.set(_conditionals.supportedActions.required + '_' + this.key, {
      rule: function rule() {
        return !_this.isEmpty && (!_this.componentClass.isEmpty || !_this.componentClass.isEmpty(_this));
      },
      hint: function hint(value) {
        return _react2.default.createElement(_RuleHint2.default, {
          key: 'req_' + _this.key,
          hint: _WebformUtils2.default.getCustomValue(_this.element, 'requiredError', _this.formStore.form.settings) || _WebformUtils2.default.getErrorMessage(element, '#required_error') || _WebformUtils2.default.getErrorMessage(element, '#help') || 'This field is required',
          tokens: {
            value: value,
            name: _this.element['#title']
          }
        });
      },
      shouldValidate: function shouldValidate(field) {
        return field.isBlurred;
      }
    });

    var pattern = this.element['#pattern'];
    if (pattern) {
      _rules2.default.set('pattern_' + this.key, {
        rule: function rule() {
          var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
          return new RegExp(pattern).test(value) || _this.isEmpty;
        },
        hint: function hint(value) {
          var patternError = _WebformUtils2.default.getCustomValue(_this.element, 'patternError', _this.formStore.form.settings);
          var populatedPatternError = (0, _getNested2.default)(function () {
            return _this.formStore.form.settings.custom_elements.patternError['#options'][patternError];
          }, _this.element['#patternError'] || _WebformUtils2.default.getErrorMessage(element, '#required_error') || 'Please enter a valid value.');
          return _react2.default.createElement(_RuleHint2.default, { key: 'pattern_' + _this.key, hint: populatedPatternError, tokens: { value: value } });
        },
        shouldValidate: function shouldValidate(field) {
          return field.isBlurred && _WebformUtils2.default.validateRule(_rules2.default.get(_conditionals.supportedActions.required + '_' + _this.key), field);
        }
      });
    }
  }

  /**
   * Checks is the field is currently valid.
   * @returns {boolean}
   */


  /**
   * By default, the value is ''.
   * This value gets updated in the WebformElement component.
   * @type {string}
   */


  /**
   * @var {Field}
   */


  (0, _createClass3.default)(Field, [{
    key: 'getValue',


    /**
     * @deprecated
     * Use field.value.
     */
    value: function getValue() {
      return this.value;
    }
  }, {
    key: 'valid',
    get: function get() {
      return this.errors.length === 0;
    }
  }, {
    key: 'validations',
    get: function get() {
      var _this2 = this;

      var validations = [this.required ? _conditionals.supportedActions.required + '_' + this.key : null, this.element['#pattern'] ? 'pattern_' + this.key : null];

      var populatedValidations = validations.map(function (validation) {
        return _rules2.default.get(validation) || null;
      });

      var customValidationKeys = (0, _getNested2.default)(function () {
        return _this2.componentClass.meta.validations;
      }, []).map(function (validation) {
        return validation(_this2) || null;
      });

      populatedValidations.push.apply(populatedValidations, (0, _toConsumableArray3.default)(customValidationKeys.map(function (k) {
        return _rules2.default.get(k);
      }).filter(function (k) {
        return k;
      })));

      return populatedValidations;
    }

    /**
     * This is used to check if the 'required' validation is met.
     * @returns {boolean}
     */

  }, {
    key: 'isEmpty',
    get: function get() {
      if (this.value === '' || this.value === false) {
        return true;
      }

      if (this.element['#mask']) {
        var mask = this.element['#mask'].replace(/9|a|A/g, '_');
        return this.value === mask;
      }

      return false;
    }
  }, {
    key: 'errors',
    get: function get() {
      var _this3 = this;

      var validations = this.validations;
      var field = this;

      // Field is always valid, if there is none, OR the field is invisible, OR a parent is invisible.
      if (!field || !this.visible) {
        return [];
      }

      var errors = [];

      // Check if there is a static 'validate' function on the component class.
      if (typeof field.componentClass.validate === 'function') {
        errors.push.apply(errors, (0, _toConsumableArray3.default)(field.componentClass.validate(this)));
      }

      var fails = validations ? validations.filter(function (validation) {
        return !_WebformUtils2.default.validateRule(validation, field);
      }) : [];

      errors.push.apply(errors, (0, _toConsumableArray3.default)(fails.map(function (rule) {
        return rule.hint(_this3.value);
      })));

      return errors;
    }
  }, {
    key: 'visible',
    get: function get() {
      var lookUps = (0, _mobx.values)(this.lookUps);
      if (lookUps.length > 0 && lookUps.every(function (l) {
        return l.lookUpHide && !l.lookUpSent;
      })) return false;
      return (this.parent ? this.parent.visible : true) && typeof this.conditionalLogicResults.visible === 'undefined' ? true : this.conditionalLogicResults.visible;
    }
  }, {
    key: 'required',
    get: function get() {
      return typeof this.conditionalLogicResults.required === 'undefined' ? !!this.element['#required'] : this.conditionalLogicResults.required;
    }
  }, {
    key: 'enabled',
    get: function get() {
      var lookUps = (0, _mobx.values)(this.lookUps);
      if (lookUps.length > 0 && lookUps.every(function (l) {
        return l.lookUpDisabled;
      })) return false;
      return typeof this.conditionalLogicResults.enabled === 'undefined' ? true : this.conditionalLogicResults.enabled;
    }
  }, {
    key: 'conditionalLogicResults',
    get: function get() {
      return (0, _conditionals.checkConditionals)(this.formStore, this.key);
    }
  }]);
  return Field;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, 'component', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, 'value', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, 'isBlurred', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, 'lookUps', [_mobx.observable], {
  enumerable: true,
  initializer: function initializer() {
    return {};
  }
}), _applyDecoratedDescriptor(_class.prototype, 'valid', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'valid'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'validations', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'validations'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'isEmpty', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'isEmpty'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'errors', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'errors'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'visible', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'visible'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'required', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'required'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'enabled', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'enabled'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'conditionalLogicResults', [_mobx.computed], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'conditionalLogicResults'), _class.prototype)), _class);
exports.default = Field;